import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { NewGroupChatScreenComponent } from './new-group-chat-screen-component';
export const NewGroupChatScreen: NavigationScreen<'new-group-chat'> = withOptionalMetrics(
  'NewGroupChatScreen',
  withErrorBoundary(NewGroupChatScreenComponent),
);
